import { PARSED_API_ERR_RESPONSE } from '@/api/config';

import ERROR_CODE_DICT from '../../constant/error/apiErrorCodeParsed.json';
import ERROR_TYPE_DICT from '../../constant/error/apiErrorTypeParsed.json';
import { DEFAULT_CONTENT, DEFAULT_TITLE } from '../../constant/error/defaultErrorTitleContent';

export type ErrorCode = keyof typeof ERROR_CODE_DICT;
type DefaultContentType = keyof typeof DEFAULT_CONTENT;
type DefaultTitleType = keyof typeof DEFAULT_TITLE;
type ErrorType = keyof typeof ERROR_TYPE_DICT;

/**
 * Returns object of error message.
 *
 * @param {string} code The code for api error code.
 * @param {string[]} errorType The errorType for specific error column.
 */
export const processApiError = (code: ErrorCode, errorType: ErrorType[] = []) => {
  let title = '';
  let content = '';
  const data = ERROR_CODE_DICT[code];
  if (data) {
    // code exist in data, if code didn't exist, then need to execute generator
    // TODO
    if (errorType.length === 0 || !data.hasType) {
      // No errorType received or this api does not have errorType in the document
      title = data.title;
      content = data.content;
      if (title.search('DEFAULT') !== -1) {
        title = DEFAULT_TITLE[title.split('.')[1] as DefaultTitleType]; // Replace title with selected default title
      }
      if (content.search('DEFAULT') !== -1) {
        content = DEFAULT_CONTENT[content.split('.')[1] as DefaultContentType]; // Replace content with selected default content
      }
      if (content.search('[TYPE]') !== -1) {
        // handle API which may have errorType but no errorType get
        content = content.replace('[TYPE]', '資料');
      }
    } else {
      title = data.title;
      content = data.content;
      if (title.search('DEFAULT') !== -1) {
        title = DEFAULT_TITLE[title.split('.')[1] as DefaultTitleType]; // Replace title with selected default title
      }
      if (content.search('DEFAULT') !== -1) {
        content = DEFAULT_CONTENT[content.split('.')[1] as DefaultContentType]; // Replace content with selected default content
      }
      if (content.search('[TYPE]') !== -1) {
        // Replace [TYPE] parameter with string
        const _errorTypeStingList: string[] = [];
        // eslint-disable-next-line array-callback-return
        errorType.map((_errorType) => {
          _errorTypeStingList.push(ERROR_TYPE_DICT[_errorType]);
        });
        content = content.replace('[TYPE]', _errorTypeStingList.join('、'));
      }
    }
    if (title === '') {
      title = DEFAULT_TITLE.DEFAULT;
    }
    if (content === '') {
      content = `${DEFAULT_CONTENT.DEFAULT}錯誤代碼：${code}。`;
    }
  } else {
    title = DEFAULT_TITLE.DEFAULT;
    content = `${DEFAULT_CONTENT.DEFAULT}錯誤代碼：${code}。`;
  }
  return { title, content };
};

type CustomErrorCode =
  (typeof PARSED_API_ERR_RESPONSE)[keyof typeof PARSED_API_ERR_RESPONSE]['code'];

export const getErrMessage = (errCode: ErrorCode | CustomErrorCode) => {
  switch (errCode) {
    case PARSED_API_ERR_RESPONSE.FORBIDDEN.code:
      return PARSED_API_ERR_RESPONSE.FORBIDDEN.errMessage;
    case PARSED_API_ERR_RESPONSE.NOT_FOUND.code:
      return PARSED_API_ERR_RESPONSE.NOT_FOUND.errMessage;
    case PARSED_API_ERR_RESPONSE.PAYLOAD_TOO_LARGE.code:
      return PARSED_API_ERR_RESPONSE.PAYLOAD_TOO_LARGE.errMessage;
    case PARSED_API_ERR_RESPONSE.INTERNAL_SERVER_ERROR.code:
      return PARSED_API_ERR_RESPONSE.INTERNAL_SERVER_ERROR.errMessage;
    case PARSED_API_ERR_RESPONSE.NO_RESPONSE.code:
      return PARSED_API_ERR_RESPONSE.NO_RESPONSE.errMessage;
    case PARSED_API_ERR_RESPONSE.GRAPHQL_NO_DATA.code:
      return PARSED_API_ERR_RESPONSE.GRAPHQL_NO_DATA.errMessage;
    default:
      return processApiError(errCode).content.replace(/<br\/?>/g, '');
  }
};
